var map = {
	"./download.svg": 4655,
	"./icon01.svg": 6583,
	"./icon03.svg": 927,
	"./icon2.svg": 3943,
	"./icon_down.svg": 5639,
	"./icon_up.svg": 6737,
	"./phone.svg": 1688,
	"./举办项目竞赛.svg": 4037,
	"./互联网.svg": 6728,
	"./从无到有品牌.svg": 838,
	"./其他法律服务.svg": 7056,
	"./协助举办定期开源技术沙龙.svg": 5297,
	"./协助举办开源社区联动合作.svg": 9893,
	"./右 (1).svg": 11,
	"./右.svg": 4151,
	"./合规审查.svg": 3351,
	"./商标保护.svg": 2175,
	"./展开.svg": 349,
	"./建立体系.svg": 4837,
	"./开发和运维.svg": 6619,
	"./开源法律咨询与支持.svg": 2117,
	"./开源法律问题研究.svg": 8775,
	"./托管维护.svg": 7461,
	"./择律-公用-收起.svg": 2232,
	"./接受捐赠.svg": 518,
	"./推广和传播.svg": 6349,
	"./活动策划.svg": 3126,
	"./知识产权咨询与支持.svg": 4434,
	"./签约.svg": 9500,
	"./联合举办线上线下技术社区运营.svg": 4211,
	"./行政管理.svg": 2372,
	"./设计开发周边.svg": 2869,
	"./账户系统.svg": 4558,
	"./资助项目.svg": 8436,
	"./项目测试.svg": 3360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;